export class Priority {
  static HIGH = 3
  static MEDIUM = 2
  static LOW = 1
  static NO = 0

  constructor(value) {
    this.value = value
  }

  label() {
    return {
      [Priority.HIGH]: "High",
      [Priority.MEDIUM]: "Medium",
      [Priority.LOW]: "Low",
      [Priority.NO]: "No",
    }[this.value]
  }
}
